import styled, { css } from 'styled-components';
import { pxToRems, breakpoints } from '@awaze/design-system.utils.react';
import { Divider } from '@awaze/design-system.components.divider';
import { Text } from '@awaze/design-system.components.text';
import { Button } from '@awaze/design-system.components.button';
export const StyledButton = styled(Button) `
  width: 100%;
  margin-bottom: ${pxToRems(8)};
  padding-bottom: ${pxToRems(8)};
`;
export const AutocompleteListItemTextWrapper = styled.div `
  display: block;
  text-align: left;
`;
export const StyledDivider = styled(Divider) `
  display: none;

  @media screen and (min-width: ${breakpoints[0]}px) {
    display: block;
  }
`;
export const StyledText = styled(Text) `
  width: 100%;
  margin-top: ${pxToRems(15)};
  padding-bottom: ${pxToRems(8)};

  &.secondary-title {
    margin-top: ${pxToRems(28)};
    padding-bottom: ${pxToRems(12)};

    @media screen and (min-width: ${breakpoints[0]}px) {
      margin-top: ${pxToRems(15)};
    }
  }

  @media screen and (min-width: ${breakpoints[0]}px) {
    margin-top: ${pxToRems(5)};
  }
`;
export const StyledLoading = styled.p `
  font-weight: 500;
  margin: ${pxToRems(15)} 0 ${pxToRems(4)};

  @media screen and (min-width: ${breakpoints[0]}px) {
    margin-top: ${pxToRems(5)};
  }
`;
export const AutocompleteContent = styled.div `
  ${({ inlineResults }) => inlineResults
    ? css `
          padding: ${pxToRems(8)} 0;
          > button {
            border-top: 1px solid ${({ theme }) => theme.ColorGrey100};
            border-radius: 0;
            padding: ${pxToRems(10)} ${pxToRems(8)} ${pxToRems(8)};
            margin-bottom: 0;

            &.last-auto-complete {
              border-bottom: 1px solid ${({ theme }) => theme.ColorGrey100};
            }
          }
        `
    : css `
          padding: 0 ${pxToRems(24)} ${pxToRems(12)};
        `}
  @media screen and (min-width: ${breakpoints[0]}px) {
    max-height: 474px;
    overflow-x: hidden;
    overflow-y: auto;
    margin: ${pxToRems(14)} 0 0;

    ::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.2);
      box-shadow: 0 0 1px rgba(255, 255, 255, 0.3);
    }

    ${({ useLegacyDestinationSelector }) => useLegacyDestinationSelector &&
    css `
        max-height: none;
        padding-top: ${pxToRems(8)};
      `}
  }
`;
export const StyledContainer = styled.div `
  position: relative;
  width: 100%;
  height: 100%;

  input {
    padding-right: ${pxToRems(40)};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 0;
  }

  * {
    height: 100%;
  }
`;
export const StyledClosebutton = styled.button `
  cursor: pointer;
  background: none;
  border: none;
  border-radius: 4px;
  position: absolute;
  padding: ${pxToRems(12)};
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    fill: ${({ theme }) => theme.ColorGrey800};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.ColorBrandPrimary};
  }
`;
export const AutocompleteWrapperStyled = styled.div `
  background-color: ${({ theme }) => theme.ColorGrey400};
  padding: ${pxToRems(50)};
`;
export const InnerPopoverStyled = styled.div `
  width: ${({ popoverWidth }) => (popoverWidth || `auto`)};
`;
export const AutocompleteListItemText = styled.div `
  display: grid;
  flex-direction: column;
  align-items: left;
`;
export const AutocompleteListItemIcon = styled.div `
  fill: currentColor;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 0 0 ${pxToRems(20)};
`;
//# sourceMappingURL=autocomplete.styles.js.map